import { Button } from "primereact/button";
import { Calendar } from "primereact/calendar";
import { Dialog } from "primereact/dialog";
import React, { useEffect, useState } from "react";
import { getUserData } from "../../utils/localStorage";
import { warehouseUserStageJob } from "./WarehouseUserList";
import { formatDateWithTime } from "../../constants/DateUtil/DateUtil";

const WarehouseUserStageModal = ({
  warehouseUserStageModalVisible,
  setWarehouseUserStageModalVisible,
  selectedQrCodeData,
}) => {
  const { storeData, brandProfileData, warehouseData } = getUserData();

  let warehouseId = warehouseData.id;
  let brandId = brandProfileData.id;
  const { id } = selectedQrCodeData;

  const [stageData, setStageData] = useState([]);

  const fetchData = (data) => {
    warehouseUserStageJob(warehouseId, data)
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;
          setStageData(Res);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  };

  useEffect(() => {
    const data = {
      brandId: brandId,
      warehouseIds: [warehouseId],
      qrCodeIdIn: [id],
    };
    fetchData(data);
  }, [id]);

  const handleModalClose = () => {
    setWarehouseUserStageModalVisible(!warehouseUserStageModalVisible);
  };

  const renderCardItem = () => {
    return stageData?.map((item, index) => (
      <div>
        <div className="flex-1 my-2 mx-2">
          <div className=" shadow-4">
            <div className="flex flex-1">
              <div
                className="flex-1 px-3 "
                style={{
                  backgroundColor: "#E2F4F8",
                }}
              >
                <p
                  className="text-md font-normal capitalize"
                  style={{ color: "#75879B" }}
                >
                  Priority :
                </p>
                <p className="text-lg font-medium capitalize">
                  P -{" "}
                  {item.wareHouseGarmentProcessStageUser
                    .wareHouseGarmentProcessStage.priority +
                    " (" +
                    item.wareHouseGarmentProcessStageUser
                      .wareHouseGarmentProcessStage.stage +
                    ")"}
                </p>
              </div>
              <div
                className="flex-1 px-3 py-1"
                style={{
                  backgroundColor: "#F8FFEE",
                }}
              >
                <p
                  className="text-md font-normal capitalize"
                  style={{ color: "#75879B" }}
                >
                  Status :
                </p>
                <p className="text-lg font-medium capitalize">{item.status}</p>
              </div>
            </div>
            <div className="flex flex-1">
              <div
                className="flex-1 px-3 py-1"
                style={{
                  backgroundColor: "#F8FFEE",
                }}
              >
                <p
                  className="text-md font-normal capitalize"
                  style={{ color: "#75879B" }}
                >
                  Start On :
                </p>
                <p className="text-lg font-medium capitalize">
                  {item.startOn === null
                    ? ""
                    : formatDateWithTime(item.startOn)}
                </p>
              </div>
              <div
                className="flex-1 px-3 py-1"
                style={{
                  backgroundColor: "#E2F4F8",
                }}
              >
                <p
                  className="text-md font-normal capitalize"
                  style={{ color: "#75879B" }}
                >
                  End On :
                </p>
                <p className="text-lg font-medium capitalize">
                  {item.endOn === null ? "" : formatDateWithTime(item.endOn)}
                </p>
              </div>
            </div>
            <div className="flex flex-1">
              <div
                className="flex-1 px-3 py-1"
                style={{
                  backgroundColor: "#E2F4F8",
                }}
              >
                <p
                  className="text-md font-normal capitalize"
                  style={{ color: "#75879B" }}
                >
                  WareHouse User Name :
                </p>
                <p className="text-lg font-medium capitalize">
                  {item.wareHouseGarmentProcessStageUser.wareHouseUser.user
                    .firstName +
                    " " +
                    item.wareHouseGarmentProcessStageUser.wareHouseUser.user
                      .lastName}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    ));
  };

  return (
    <div className="flex justify-content-center">
      <Dialog
        modal
        visible={warehouseUserStageModalVisible}
        style={{ width: "50vw" }}
        onHide={() => {
          if (!warehouseUserStageModalVisible) return;
          handleModalClose();
        }}
        content={({ hide }) => (
          <div
            className="flex flex-column gap-1"
            style={{
              borderRadius: "12px",
              backgroundColor: "#fff",
            }}
          >
            <div
              className="flex border-round-xl  justify-content-between align-items-center  px-4 py-2"
              style={{
                backgroundImage:
                  "radial-gradient(circle at left top, #2B70D7, #1752AA)",
              }}
            >
              <div></div>

              <div>
                <p className=" text-3xl text-primary-50 font-semibold text-center">
                  {stageData[0]?.qrCodeInfo?.garmentName}
                </p>
                <p className=" text-2xl text-primary-50 font-semibold text-center">
                  {stageData[0]?.qrCodeInfo?.inTime === null ? (
                    ""
                  ) : (
                    <p>
                      (In -{" "}
                      {formatDateWithTime(stageData[0]?.qrCodeInfo?.inTime)})
                    </p>
                  )}
                  {stageData[0]?.qrCodeInfo?.processedOn === null ? (
                    ""
                  ) : (
                    <p>
                      (PR. -{" "}
                      {formatDateWithTime(
                        stageData[0]?.qrCodeInfo?.processedOn
                      )}
                      )
                    </p>
                  )}
                </p>
              </div>
              <Button
                label="x"
                onClick={(e) => hide(e)}
                text
                className=" text-2xl text-primary-50 border-1 border-white-alpha-30 hover:bg-white-alpha-10"
              ></Button>
            </div>

            <div
              className="h-30rem scroll-bar mb-2"
              style={{
                overflowY: "scroll",
              }}
            >
              {renderCardItem()}
            </div>
          </div>
        )}
      ></Dialog>
    </div>
  );
};

export default WarehouseUserStageModal;
